import {ListButton, TopToolbar} from "react-admin";
import * as React from "react";

const ShowActions = (props) => (
    <TopToolbar {...props}>
        <ListButton label={"zurück zur Liste"} /* FIXME: to={props.basePath}*/ />
    </TopToolbar>
)

export default ShowActions;